import {getCourseWithTeacher} from '@/api/attendance'
import {getStudentShortList, getTimingOneToOneTeacher,enrollmentApi} from '@/api/course-builderapi'
export const  GlobalCourseMixin = {

  data () {
    return {
      courseList:[],
      teacherList:[],
      settingObject:null,
      teacher_id:null,
      weekOption: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      course_start_date:'',
      course_start_time:'',
      monthDay: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31
      ],
      selectTiming:[],
      studentList:[],
      selectStudentId:null


    }
  },
  methods:{
    limiter (event) {
      
      if (event.length > this.max_days_in_week_or_month) {
        
        event.pop()
      }
    },
      
    async fetchCourseWithList (type = null) {
      
      try {
        const customer_id = localStorage.getItem('customer_id')
        const payload = {}

        if (type === 'online_one_2_one') {
          payload.course_class_type = ['online_one_2_one', 'offline_one_2_one']
              
        }
        const {data} = await getCourseWithTeacher(customer_id, payload)
        
        
        this.courseList = data.data.course_list
        
      } catch (error) {
        
      }
    },
    async getStudentList () {
      try {
        const customer_id = localStorage.getItem('customer_id')
        const {data} = await getStudentShortList(customer_id)
        
        this.studentList = data.data.clientUser
      } catch (error) {
        
      }
    },
    async getTiming () {
      if (!this.course_start_date) {
        return false
      }
      
      
      
      
      if (!this.teacher_id || !this.course_start_date || !this.selected_course_id || !this.selectStudentId) {
        
        this.course_start_date = ''
        this.showSuccessMessage('Error', 'Must Select Course, Student And Teachers before Getting Time', 'danger')
      } else {
        const payload = {
          course_id:this.selected_course_id,
          schedule_date:this.course_start_date,
          teacher_id:this.teacher_id,
          platform_customer_id:localStorage.getItem('customer_id'),
          client_user_id:this.selectStudentId
        }
        try {
          
          
          const {data} = await getTimingOneToOneTeacher(payload)
          if (!data.data[0].length) {
            this.showSuccessMessage('Error', 'No Dates Available for this teacher and course', 'danger')

          } else {
            this.selectTiming = data.data[0]

          }
          
        } catch (error) {
          
        }
        // 
      }
        
        
    }
  }
}